// src/grecaptcha/script.ts
import { loadScriptAsync } from "@wbk/utils";
var inFlight = /* @__PURE__ */ new Map();
var loadScriptOnce = (id, url) => {
  var _a;
  let pending = inFlight.get(id);
  if (!pending) {
    (_a = document.getElementById(id)) == null ? void 0 : _a.remove();
    pending = loadScriptAsync({ id, url }).finally(() => inFlight.delete(id));
    inFlight.set(id, pending);
  }
  return pending;
};

export {
  loadScriptOnce
};
//# sourceMappingURL=chunk-JHUVX63K.mjs.map